import { formatURIComponent } from './utils'

export default (instance:string) => {

    const makeUrl = (path:string) => {
        return `/browser2?file_path=${formatURIComponent(path, instance)}&menu_key=opening&instance=${instance}`
    }

    return [{
        pageLayout: 'tabs',
        slogan: '华美服务 = 咨询服务 + 华美云 + 尽管问',
        pageTitle: '开业筹备',
        pageTitleIcon: '',
        background_img: '/backgrounds/sunny.jpg',
        description: `华美的开业筹备服务涵盖从证照办理、团队组建到开业营销的全流程支持。很多业主在筹备阶段常遇到证照流程复杂导致延期、人员招聘培训不足，以及开业缺乏有效营销方案等痛点。华美凭借丰富的行业资源和标准化操作流程，帮助客户规避筹备风险，确保酒店以最佳状态迎接市场。`,
        icons: [
            {
                name: '开业筹备',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('/内容文件/华美/华美简介/5.开业筹备.pdf'),
                path: "四库赋能-酒店建设/开业筹备/成功案例"
            },
            {
                name: '华美项目',
                img: '/icons/成功案例.svg',
                background: 'black',
                url: makeUrl('华美项目'),
                path: "四库赋能-酒店建设/开业筹备/华美项目"
            },
            {
                name: '数据赋能',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/开业筹备/数据赋能'),
                path: "四库赋能-酒店建设/开业筹备/数据赋能"
            },
            {
                name: '全球案例',
                img: '/icons/案例库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/开业筹备/全球案例/全球案例（开业筹备）.xlsx'),
                path: "四库赋能-酒店建设/开业筹备/全球案例"
            },
            {
                name: '预警问题',
                img: '/icons/工具库.svg',
                background: 'black',
                url: makeUrl('/内容文件/四库赋能-酒店建设/开业筹备/预警问题/预警问题（开业筹备）.xlsx'),
                path: "四库赋能-酒店建设/开业筹备/预警问题"
            },
        ]
    }]
}